export class PasswordParams {
  oldPassword = '';
  password = '';
  repeatPassword = '';

  get isEmpty(): boolean {
    return this.oldPassword == '' && this.password == '' && this.repeatPassword == '';
  }
}
